import React from "react";
import overview from "../../../../content/blogs/AirPlay/AirPlay_overview.jpeg";
import highlight from "../../../../content/blogs/AirPlay/highlight.png";
import flipchart from "../../../../content/blogs/AirPlay/feature/flipchart.png";
import monitor from "../../../../content/blogs/AirPlay/feature/monitor.png";
import donga from "../../../../content/blogs/AirPlay/media/donga.png";
import pcmag from "../../../../content/blogs/AirPlay/media/pcmag.png";
import wired from "../../../../content/blogs/AirPlay/media/wired.png";
import digitaltrends from "../../../../content/blogs/AirPlay/media/digitaltrends.png";
import newsweek from "../../../../content/blogs/AirPlay/media/newsweek.png";
import hometheater from "../../../../content/blogs/AirPlay/media/hometheater.png";
import tomsguide from "../../../../content/blogs/AirPlay/media/tomsguide.png";
import t3 from "../../../../content/blogs/AirPlay/media/t3.png";
export default {
  React,
  overview,
  highlight,
  flipchart,
  monitor,
  donga,
  pcmag,
  wired,
  digitaltrends,
  newsweek,
  hometheater,
  tomsguide,
  t3
};